import { render } from "./image-input.vue?vue&type=template&id=0c664470"
import script from "./image-input.vue?vue&type=script&lang=js"
export * from "./image-input.vue?vue&type=script&lang=js"

import "./image-input.vue?vue&type=style&index=0&id=0c664470&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__